import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { ProductPresentation } from './components/ProductPresentation';
import { Bonuses } from './components/Bonuses';
import { Guarantee } from './components/Guarantee';
import { Reviews } from './components/Reviews';
import { FAQ } from './components/FAQ';
import { FinalOffer } from './components/FinalOffer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-[#0a0a0a] text-gray-200 font-sans selection:bg-brand-red selection:text-white overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Benefits data-id="element-3" />
      <Reviews data-id="element-4" />
      <ProductPresentation data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Guarantee data-id="element-7" />
      <Testimonials data-id="element-8" />
      <FinalOffer data-id="element-9" />
      <FAQ data-id="element-10" />
    </main>;
}